import { MessageCircle, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, customerWaLink, thankYouMessage } from "@/lib/api";

export default function ThankYouButton({ enquiry, onSent, compact = false }) {
  if (enquiry.status !== "confirmed") return null;
  const id8 = enquiry.id.slice(0, 8);

  const send = async () => {
    window.open(customerWaLink(enquiry.phone, thankYouMessage(enquiry)), "_blank");
    try {
      await api.patch(`/admin/enquiries/${enquiry.id}`, { reminder_sent: true });
      onSent?.(enquiry.id);
      toast.success("WhatsApp opened — thank-you marked as sent");
    } catch {
      toast.error("Could not mark reminder as sent");
    }
  };

  if (enquiry.reminder_sent) {
    return (
      <span className={`flex items-center gap-1 text-emerald-700 font-semibold ${compact ? "text-[10px]" : "text-xs"}`} data-testid={`thankyou-sent-${id8}`}>
        <CheckCircle2 size={compact ? 11 : 13} /> Thank-you sent
      </span>
    );
  }
  return (
    <button onClick={send} data-testid={`thankyou-send-${id8}`}
      className={`flex items-center gap-1.5 bg-[#25D366] text-white font-semibold rounded-full hover:brightness-110 transition-all ${compact ? "text-[10px] px-2.5 py-1" : "text-xs px-3.5 py-1.5"}`}>
      <MessageCircle size={compact ? 11 : 13} /> Send thank-you & review link
    </button>
  );
}
